export const surprisePackageCategoryId = 10;